import { render, staticRenderFns } from "./powerFoot.vue?vue&type=template&id=4f6d0b94&scoped=true&"
import script from "./powerFoot.vue?vue&type=script&lang=js&"
export * from "./powerFoot.vue?vue&type=script&lang=js&"
import style0 from "./powerFoot.vue?vue&type=style&index=0&id=4f6d0b94&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6d0b94",
  null
  
)

export default component.exports